/* eslint-disable no-plusplus */
/* eslint-disable security/detect-object-injection */
import React, { useCallback, useContext, useEffect, useState } from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { UserService } from 'gw-capability-gateway';
import { AccountService } from 'gw-capability-gateway-policy';
import { platformMessages, FormModalPopover } from 'ml-components-platform-react';
import { useModal } from '@jutro/components';
import { GatewayBillingService } from 'gw-capability-gateway-billing';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react'
import { DateUtil } from '@xengage/gw-portals-util-js';

import classNames from 'classnames';
import MLPolicyDocumentsComponent from '../../Components/MLPolicyDocumentsComponent/MLPolicyDocumentsComponent';
import metadata from './MLDocuments.metadata.json5';
import messages from './MLDocuments.messages';
import styles from './MLDocuments.module.scss';

import shareDocumentsPopupMetadata from './MLShareDocumentsPopup.metadata.json5';

const BUNDLED_TAB = 'bundled';
const POLICY_TAB = 'policy';
const BILLING_TAB = 'billing';
const SENT_TAB = 'sent';
const CARDS_TAB = 'cards';
const TIMEFRAME_30_DAYS = '30days';
const TIMEFRAME_90_DAYS = '90days';
const TIMEFRAME_6_MONTHS = '6months';
const TIMEFRAME_1_YEAR = '1year';
const TIMEFRAME_3_YEARS = '3years';
const TIMEFRAME_5_YEARS = '5years';

const emailSubTypes = [
    'agent_of_record_change',
    'animal_liability_exclusion',
    'application',
    'association_affinity',
    'consent_to_rate',
    'hurricane_windstorm_deductible',
    'hurricane_windstorm_loss_mitigation',
    'medical_election_rejection',
    'mine_subsidence_offer_form',
    'mine_subsidence_rejection',
    'named_driver_exclusion_form',
    'notice_of_benefits',
    'one_time_eft_authorization',
    'payroll_authorization',
    'personal_property_exclusion',
    'pip_election_rejection',
    'private_structures_exclusion_form',
    'recurring_credit_or_debit_card_authorization',
    'recurring_eft_authorization',
    'request_for_name_change',
    'scheduled_value_onroof_ext',
    'statement_of_no_loss',
    'tcpa',
    'third_party_designee',
    'tort_form',
    'uim_election_rejection',
    'uim_stacking_rejection',
    'um_election_rejection',
    'um_stacking_rejection',
    'um_uim_election_rejection',
    'umpd_election_rejection',
    'windstorm_and_hail_exclusion',
    'confirmation_of_coverage',
    'confirmation_of_coverage_to_mortgagee',
    'business_use_confirmation_of_coverage',
    'certificate_of_insurance',
    'confirmation_of_driver',
    'coi_dmv_confirmation',
    'mortgagee_notice',
    'quote_proposal',
    'auto_identification_cards_mobile',
    'auto_identification_cards_pdf',
    'auto_identification_cards_temporary',
    'temporary_evidence_of_auto_insurance_nj_auto'
];

const MLDocuments = (props) => {
    const modalApi = useModal();
    const { accountInfo } = props;

    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);

    const { authHeader } = useAuthentication();

    const {
        showProgressDialog
    } = MLModalService();

    const [shareDocumentView, setShareDocumentView] = useState(
        {
            emailAddress1: accountInfo.emailAddress1,
            faxNumber: '',
            print: false,
            distributionMethod: '',
            documentsToShare: []
        }
    );
    const newShareDocumentView = viewModelService.create(shareDocumentView, 'pc', 'metlife.edge.capabilities.gateway.account.dto.ShareDocumentDTOML');

    const [activeTab, setActiveTab] = useState(POLICY_TAB);
    const [allDocuments, setAllDocuments] = useState([]);
    const [bundledDocuments, setBundledDocuments] = useState([]);
    const [policyDocuments, setPolicyDocuments] = useState([]);
    const [billingDocuments, setBillingDocuments] = useState([]);
    const [documentsYouSentUs, setDocumentsYouSentUs] = useState([]);
    const [idCardDocuments, setIdCardDocuments] = useState([]);
    const [docsThatCannotBeEmailed, setDocsThatCannotBeEmailed] = useState([]);
    const [filteredBundledDocuments, setFilteredBundledDocuments] = useState([]);
    const [filteredPolicyDocuments, setFilteredPolicyDocuments] = useState([]);
    const [filteredBillingDocuments, setFilteredBillingDocuments] = useState([]);
    const [filteredDocumentsYouSentUs, setFilteredDocumentsYouSentUs] = useState([]);
    const [filteredIdCardDocuments, setFilteredIdCardDocuments] = useState([]);
    const [ dayFilter, setDayFilter] = useState(TIMEFRAME_30_DAYS);
    const [ documentData, setDocumentData ] = useState([]);
    const [isUserRetentionAgent, setIsUserRetentionAgent] = useState(false);

    const getLeftMostNonEmptyTabAsActive = useCallback(() => {
        if (bundledDocuments.length > 0) {
            return BUNDLED_TAB;
        }
        if (policyDocuments.length > 0) {
            return POLICY_TAB;
        }
        if (billingDocuments.length > 0) {
            return BILLING_TAB;
        }
        if (documentsYouSentUs.length > 0) {
            return SENT_TAB;
        }
        if (idCardDocuments.length > 0) {
            return CARDS_TAB;
        }
        return POLICY_TAB;
    }, [billingDocuments, bundledDocuments, documentsYouSentUs, idCardDocuments, policyDocuments]);

    const addDays = (date, daysToAdd) => {
        date.setDate(date.getDate() + daysToAdd);
        return date;
    };

    const filterDocumentsByDate = (docs, filterDate) => {
        if (!docs) {
            return [];
        }
        if (!filterDate) {
            return docs;
        }
        return docs.filter((doc) => {
            const dateFilter = new Date(doc.dateModified)
            return dateFilter >= filterDate;
        });
    };

    const setFilterDate = useCallback((option) => {
        let filterDate;
        const currentDate = DateUtil.currentDate();
        if (option === TIMEFRAME_30_DAYS) {
            filterDate = addDays(currentDate, -30);
        } else if (option === TIMEFRAME_90_DAYS) {
            filterDate = addDays(currentDate, -90);
        } else if (option === TIMEFRAME_6_MONTHS) {
            filterDate = new Date(currentDate.setMonth(currentDate.getMonth() - 6));
        } else if (option === TIMEFRAME_1_YEAR) {
            filterDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1));
        } else if (option === TIMEFRAME_3_YEARS) {
            filterDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 3));
        } else if (option === TIMEFRAME_5_YEARS) {
            filterDate = new Date(currentDate.setFullYear(currentDate.getFullYear() - 5));
        }
        return filterDate;
    },[]);

    const getDocumentsData = useCallback(() => {
        let docsData;
        switch (activeTab) {
            case BUNDLED_TAB:
                docsData = filteredBundledDocuments;
                break;
            case POLICY_TAB:
                docsData = filteredPolicyDocuments;
                break;
            case BILLING_TAB:
                docsData = filteredBillingDocuments;
                break;
            case SENT_TAB:
                docsData = filteredDocumentsYouSentUs;
                break;
            case CARDS_TAB:
                docsData = filteredIdCardDocuments;
                break;
            default:
                break;
        }
        return docsData;
    },[activeTab, filteredBillingDocuments, filteredBundledDocuments, filteredDocumentsYouSentUs, filteredIdCardDocuments, filteredPolicyDocuments]);

    const updateFilteredDocsByDate = useCallback((selectedValue) => {
        const filterDate = setFilterDate(selectedValue);
        setFilteredBundledDocuments(filterDocumentsByDate(bundledDocuments, filterDate));
        setFilteredPolicyDocuments(filterDocumentsByDate(policyDocuments, filterDate));
        setFilteredBillingDocuments(filterDocumentsByDate(billingDocuments, filterDate));
        setFilteredDocumentsYouSentUs(filterDocumentsByDate(documentsYouSentUs, filterDate));
        setFilteredIdCardDocuments(filterDocumentsByDate(idCardDocuments, filterDate));
        setDayFilter(selectedValue);
        setDocumentData(getDocumentsData());
    },[billingDocuments, bundledDocuments, documentsYouSentUs, getDocumentsData, idCardDocuments, policyDocuments, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredBundledDocuments(filterDocumentsByDate(bundledDocuments, filterDate));
    }, [dayFilter, bundledDocuments, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredPolicyDocuments(filterDocumentsByDate(policyDocuments, filterDate));
    }, [dayFilter, policyDocuments, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredBillingDocuments(filterDocumentsByDate(billingDocuments, filterDate));
    }, [dayFilter, billingDocuments, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredDocumentsYouSentUs(filterDocumentsByDate(documentsYouSentUs, filterDate));
    }, [dayFilter, documentsYouSentUs, setFilterDate]);

    useEffect(() => {
        const filterDate = setFilterDate(dayFilter);
        setFilteredIdCardDocuments(filterDocumentsByDate(idCardDocuments, filterDate));
    }, [dayFilter, idCardDocuments, setFilterDate]);
    
    useEffect(() => {
        setActiveTab(getLeftMostNonEmptyTabAsActive())
    }, [bundledDocuments, policyDocuments, billingDocuments, documentsYouSentUs, idCardDocuments, getLeftMostNonEmptyTabAsActive])

    const getAndSetAllDocuments = async (accountNumber) => {
        const currentUser = await UserService.getCurrentUser(authHeader, true);
        const userProducerCodes = currentUser.producerCodes_ML.map((code) => {
            return code.code;
        });

        let docsFromPc = [];
        try{
            docsFromPc = await AccountService.getPolicyDocumentsForAccount(accountNumber, authHeader);
        }catch(e){
            console.error(e);
            docsFromPc = [];
        }
        let docsFromBc = [];
        try{
            docsFromBc = await GatewayBillingService.getBillingDocumentsForAccount(accountNumber, userProducerCodes, authHeader);
        }catch(e){
            console.error(e);
            docsFromBc = [];
        }

        const allDocuments = [].concat(docsFromPc).concat(docsFromBc);
        setAllDocuments(allDocuments);
        return allDocuments;
    };

    useEffect(() => {
        async function fetchDocuments() {
            const allDocuments = await getAndSetAllDocuments(accountInfo.accountNumber);
            
            setBundledDocuments(allDocuments.filter((doc) => doc.isAccountLevelDocument_ML));
            setPolicyDocuments(allDocuments.filter((doc) => doc.isPolicyDocument_ML && !doc.isIDCard_ML));
            setBillingDocuments(allDocuments.filter((doc) => doc.isBillingDocument_ML));
            setDocumentsYouSentUs(allDocuments.filter((doc) => doc.isDocumentYouSentUs_ML));
            setIdCardDocuments(allDocuments.filter((doc) => doc.isIDCard_ML));
            setDocsThatCannotBeEmailed(allDocuments.filter((doc) => {
                return !emailSubTypes.includes(doc.documentSubType_Ext);
            }));
        }

        async function getIsUserRetentionAgent () {
            const userProducerCodes = await UserService.getAvailableProducerCodesForCurrentUser(
                authHeader
            );
            setIsUserRetentionAgent(userProducerCodes && !!userProducerCodes.find((c) => c.isDocRetention_ML === true));
        }

        fetchDocuments();
        getIsUserRetentionAgent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isFaxSelected = () => {
        if ((newShareDocumentView.distributionMethod.value) &&
            (newShareDocumentView.distributionMethod.value.code === 'fax_ml')) {
            return true;
        }
        return false;
    };

    const isUSPSSelected = () => {
        if ((newShareDocumentView.distributionMethod.value) &&
            (newShareDocumentView.distributionMethod.value.code === 'usps_ml')) {
            return true;
        }
        return false;
    };

    const isEmailSelected = () => {
        if ((newShareDocumentView.distributionMethod.value) &&
            (newShareDocumentView.distributionMethod.value.code === 'email')) {
            return true;
        }
        return false;
    };

    const retrieveErrorMessage = useCallback((baseErrorString) => {
        const indexOfMessageSplit = baseErrorString.indexOf('|');
        if (indexOfMessageSplit !== -1) {
            const fullErrorMessageString = baseErrorString.substring(0, indexOfMessageSplit);
            const errorMessageSplit = fullErrorMessageString.split('ErrorMessage: ');
            if (errorMessageSplit.length > 1) {
                return errorMessageSplit[1];
            }
        }
    }, []);

    const shareDocuments = async (error) => {
        const shareDocumentsPromise = AccountService.shareSelectedDocuments(newShareDocumentView.value, accountInfo.accountNumber, authHeader);
        showProgressDialog(messages.sharingDocuments, shareDocumentsPromise);
        return shareDocumentsPromise.then(() => {
            MLTagManagerService.sendFormCompleteEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_${activeTab}_Share Selected Documents`);
            return true;
        }).catch((e) => {
            error.message = retrieveErrorMessage(e.baseError);
            return false;
        })
    };

    const addRemoveDocToShare = (docID) => {
        const clonedDocumentView = _.cloneDeep(shareDocumentView);
        if (_.includes(shareDocumentView.documentsToShare, docID)) {
            _.remove(clonedDocumentView.documentsToShare, (id) => id === docID);
        } else {
            clonedDocumentView.documentsToShare.push(docID);
        }
        setShareDocumentView(clonedDocumentView);
    };

    const isTabActive = (tab) => {
        return tab === activeTab;
    };

    const openShareDocumentsPopup = ()=> {
        MLTagManagerService.sendFormStartEvent(`${MLTagManagerService.getFormName()}_${MLTagManagerService.getStepName()}_${activeTab}_Share Selected Documents`);

        const hideEmailForDocType = docsThatCannotBeEmailed.some((doc) => {
            return newShareDocumentView.documentsToShare.value.includes(doc.publicID);
        });

        const moreThanFourDocsSelected = newShareDocumentView.documentsToShare.value.length > 4;

        const mapAvailableValues = (values) => {
            const filteredValues = values.filter((value) => {
                const removeEmail = value.code === 'email' && (moreThanFourDocsSelected || hideEmailForDocType);
                const removeFax = value.code === 'fax_ml' && moreThanFourDocsSelected

                return !removeEmail && !removeFax
            })

            return filteredValues.map((type) => {
                return {
                    code: type.code,
                    name: translator({
                        id: type.name,
                        defaultMessage: type.name
                    })
                };
            });
        };

        const availableDistValues = mapAvailableValues(newShareDocumentView.distributionMethod.aspects.availableValues);

        // eslint-disable-next-line prefer-destructuring
        newShareDocumentView.distributionMethod = availableDistValues[0];

        const error = {};
        let warning = {};

        if (moreThanFourDocsSelected && hideEmailForDocType) {
            warning = { message: translator(messages.emailSubTypeNotAllowedAndTooManyToEmailOrFax)}
        } else if (hideEmailForDocType) {
            warning = { message: translator(messages.emailSubTypeNotAllowed)}
        } else if (moreThanFourDocsSelected) {
            warning = { message: translator(messages.tooManyDocsToEmailOrFax)}
        }

        const componentProps = {
            title: messages.shareDocuments,
            uiProps: shareDocumentsPopupMetadata.pageContent,
            actionBtnLabel: platformMessages.mlSubmit,
            cancelBtnLabel: platformMessages.mlCancel,
            viewModel: newShareDocumentView,
            getOverrideProps: () => {
                return {
                    shareDocumentError: {
                        messageProps: {
                            error: _.get(error, 'message', '')
                        },
                        visible: !_.isEmpty(error)
                    },
                    shareDocumentWarning: {
                        messageProps: {
                            warning: _.get(warning, 'message', '')
                        },
                        visible: !_.isEmpty(warning)
                    },
                    distributionMethodRadio: {
                        availableValues: availableDistValues,
                        value: newShareDocumentView.distributionMethod.value.code
                    },
                    emailAddressRow: {
                        visible: isEmailSelected()
                    },
                    faxNumberRow: {
                        visible: isFaxSelected()
                    },
                    uspsDesc: {
                        visible: isUSPSSelected()
                    }
                };
            },
            onFieldValueChange: (value, path) => {
                _.set(newShareDocumentView, path, value);
            },
            onAsyncSaveAction: () => {
                return shareDocuments(error);
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const isDisabledDocumentShareButton = ()=> {
        return shareDocumentView.documentsToShare.length < 1;
    };

    // Add keyboard event listener for tabs
    useEffect(() => {
        const tabList = document.getElementById('navigationSection');      

        if(tabList) {
            tabList.onkeydown = (e) => {
                if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
                    const tabs = tabList.querySelectorAll(':scope [role="tab"]');
                    const tabsArray = Array.from(tabs);
                    
                    let tabFocus = tabsArray.findIndex((el) => {                        
                        return document.activeElement.id === el.id;
                    });

                    if (e.key === "ArrowRight") {
                        tabFocus++;
                        
                        // If we're at the end, go to the start
                        if (tabFocus >= tabs.length) {
                            tabFocus = 0;
                        }
                    // Move left
                    } else if (e.key === "ArrowLeft") {
                        tabFocus--;
                        
                        // If we're at the start, move to the end
                        if (tabFocus < 0) {
                            tabFocus = tabs.length - 1;
                        }
                    }

                    tabs[tabFocus].focus();
                }
            }
        }
    }); 

    const overrideProps = {
        navigationSection: {
            'aria-label': 'Documents',
            role: 'tablist'
        },
        bundledDocumentsContainer: {
            visible: bundledDocuments.length > 0,
            className: isTabActive(BUNDLED_TAB) ? 'active' : undefined
        },
        bundledDocuments: {
            onClick: () => setActiveTab(BUNDLED_TAB),
            mlTagManagerLinkClick: "Account Summary_Documents_Bundled Documents",
            role: 'tab',
            'aria-selected': isTabActive(BUNDLED_TAB),
            tabindex: (isTabActive(BUNDLED_TAB)) ? '0' : '-1'
        },
        policyDocumentsContainer: {
            className: isTabActive(POLICY_TAB) ? 'active' : undefined
        },
        policyDocuments: {
            onClick: () => setActiveTab(POLICY_TAB),
            mlTagManagerLinkClick: "Account Summary_Documents_Policy Documents",
            role: 'tab',
            'aria-selected': isTabActive(POLICY_TAB),
            tabindex: (isTabActive(POLICY_TAB)) ? '0' : '-1'
        },
        billingDocumentsContainer: {
            className: isTabActive(BILLING_TAB) ? 'active' : undefined
        },
        billingDocuments: {
            onClick: () => setActiveTab(BILLING_TAB),
            mlTagManagerLinkClick: "Account Summary_Documents_Billing Documents",
            role: 'tab',
            'aria-selected': isTabActive(BILLING_TAB),
            tabindex: (isTabActive(BILLING_TAB)) ? '0' : '-1'
        },
        documentsYouSentUsContainer: {
            className: isTabActive(SENT_TAB) ? 'active' : undefined  
        },
        documentsYouSentUs: {
            onClick: () => setActiveTab(SENT_TAB),
            mlTagManagerLinkClick: "Account Summary_Documents_Documents You Sent Us",
            role: 'tab',
            'aria-selected': isTabActive(SENT_TAB),
            tabindex: (isTabActive(SENT_TAB)) ? '0' : '-1'
        },
        idCardsContainer: {
            className: isTabActive(CARDS_TAB) ? 'active' : undefined
        },
        idCards: {
            onClick: () => setActiveTab(CARDS_TAB),
            mlTagManagerLinkClick: "Account Summary_Documents_ID Cards",
            role: 'tab',
            'aria-selected': isTabActive(CARDS_TAB),
            tabindex: (isTabActive(CARDS_TAB)) ? '0' : '-1'
        },
        bundledDocumentsTableContainer: {
            visible: bundledDocuments.length > 0,
            className: classNames('tab-pane', { active: isTabActive(BUNDLED_TAB) })
        },
        bundledDocumentsTable: {
            documents: filteredBundledDocuments,
            addRemoveDocToShare,
            hidePolicyNumber: true
        },
        policyDocumentsTableContainer: {
            className: classNames('tab-pane', { active: isTabActive(POLICY_TAB) })
        },
        policyDocumentsTable: {
            documents: filteredPolicyDocuments,
            addRemoveDocToShare,
            isUserRetentionAgent
        },
        billingDocumentsTableContainer: {
            className: classNames('tab-pane', { active: isTabActive(BILLING_TAB) })
        },
        billingDocumentsTable: {
            documents: filteredBillingDocuments,
            addRemoveDocToShare,
            isUserRetentionAgent
        },
        documentsYouSentUsTableContainer: {
            className: classNames('tab-pane', { active: isTabActive(SENT_TAB) })
        },
        documentsYouSentUsTable: {
            documents: filteredDocumentsYouSentUs,
            addRemoveDocToShare
        },
        idCardDocumentsTableContainer: {
            className: classNames('tab-pane', { active: isTabActive(CARDS_TAB) })
        },
        idCardDocumentsTable: {
            documents: filteredIdCardDocuments,
            addRemoveDocToShare
        },
        shareSelectedDocumentsButton: {
            disabled: isDisabledDocumentShareButton(),
            onClick: openShareDocumentsPopup
        },
        documentDaysDropdown: {
            value: dayFilter,
            onValueChange: (value) => updateFilteredDocsByDate(value)
        }
    };

    const resolvers = {
        resolveComponentMap: {
            mlPolicyDocuments: MLPolicyDocumentsComponent
        },
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

export default MLDocuments;